// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteFieldBtn_root__1H_t3"};